module.exports = __webpack_public_path__ + "static/media/BannerDisplayHrefsExample@2x.74dc3318c2690ba04dc23859faec317a.jpg";